/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import {useEffect, useMemo, useState} from 'react'
//components
//constants
import {useDispatch, useSelector} from 'react-redux'
import {KTSVG} from '../../../../_metronic/helpers'
import moment from 'moment'
import {FrontendDashboardMsgInbound} from './FrontEndDashboardSlice/FrontendDashboardSlice'
import QuickMessageDrawerInner from '../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import {Link, useNavigate} from 'react-router-dom'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useGetAllCampaignListReportQuery} from '../../../../services/cellcast'
import {FixedTwoDecimal} from '../../../Utils/_helpers/string'
import {getAllUserDetails} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {
  useGetContactCountQuery,
  useLazyGetSubClientRemainingCreditQuery,
} from '../../../../services/cellcast.v2'
import {ContactStatus, GetSubClientShareCreditMode} from '../../../../services/cellcast.v2.types'
import {toast} from 'react-toastify'
import {useLayout} from '../../../../_metronic/layout/core'

/* eslint-disable jsx-a11y/anchor-is-valid */
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!

//constants
//scss
import './DashboardPage.scss'
import {configData} from '../../../../_metronic/helpers'
import {
  FrontendDashboardCalanderData,
  getFEdashboardCalander,
} from './FrontEndDashboardSlice/FrontendDashboardSlice'
import {useRef} from 'react'
import {storeReportId, storeSchedulerId} from '../reports-analytics/reportSlices/reportAnalytics'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const ChartDashboard = ({whereWhen}: any) => {
  const navigate = useNavigate()
  const userData: any = useSelector(getAllUserDetails)
  const [isShowCredit, setIsShowCredit] = useState(true)
  const [isSetCreditLimit, setIsShareCreditLimit] = useState(false)
  const [shareCreditRemain, setShareCreditRemain] = useState({
    type: '',
    sms: '-',
    mms: '-',
  })
  const [getRemainCredit] = useLazyGetSubClientRemainingCreditQuery()

  const {data: countSubscriber, isLoading: isCountSubscriberLoading} = useGetContactCountQuery({
    status: ContactStatus.subscribe,
  })
  const {data: countUnsubscribe, isLoading: isCountUnsubscribeLoading} = useGetContactCountQuery({
    status: ContactStatus.unsubscribe,
  })

  const [quickMessage, setQuickmessage] = useState(false)
  const [campType, setCampType] = useState('sms')
  const [campTypeinbound, setCampTypeInbound] = useState('sms')
  const [contact, setContact] = useState()
  const dispatch = useDispatch()

  const FELastSnapshot = useGetAllCampaignListReportQuery({
    fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
    toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
    campType,
    dashboardApi: true,
  })

  const lastSnapshot = FELastSnapshot?.data?.data?.items?.at(0)
  const lastTotalEngagement = (lastSnapshot?.clickThrough || 0) + (lastSnapshot?.replies || 0)

  const handleCalculateBadgePercentage = (value: number, total: number) => {
    return ((value / total) * 100).toFixed(0)
  }

  const credits = useSelector((state: any) => state?.userDetails?.userDetails?.data)

  const sendQuickMessage = useMemo(
    () => (
      <QuickMessageDrawerInner
        show={quickMessage}
        handleClose={() => setQuickmessage(false)}
        contacts={[{value: contact, label: contact}]}
      />
    ),
    [quickMessage]
  )
  useEffect(() => {
    dispatch(
      FrontendDashboardMsgInbound({
        camp_type: campTypeinbound,
      })
    )
  }, [campTypeinbound])

  useEffect(() => {
    if (userData && userData.subClientAccountId && userData.subClientAccountId !== '') {
      if (userData._id !== userData.ownerId) {
        setIsShowCredit(false)
        if (userData.subClientLimitConfig) {
          if (
            userData.subClientLimitConfig.smsLimitPerDay > 0 ||
            userData.subClientLimitConfig.mmsLimitPerDay > 0 ||
            userData.subClientLimitConfig.smsLimitPerMonth > 0 ||
            userData.subClientLimitConfig.mmsLimitPerMonth > 0
          ) {
            setIsShareCreditLimit(true)
          }
        }
      }
    }
  }, [userData])

  useEffect(() => {
    if (isSetCreditLimit === true) {
      getRemainCredit(null)
        .then((res) => {
          if ('data' in res) {
            if (res.data && res.data.data) {
              setShareCreditRemain({
                type: res.data.data.mode === GetSubClientShareCreditMode.Day ? `Day` : 'Month',
                sms: res.data.data.credit.sms.toString(),
                mms: res.data.data.credit.mms.toString(),
              })
            }
          } else if ('error' in res) {
            const errObj = res.error as any
            if (errObj.data.message) {
              toast.error(errObj.data.message)
            } else {
              toast.error(res.error)
            }
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    }
  }, [isSetCreditLimit])

  return (
    <>
      {AuthenticateUser('send-quick-sms') && quickMessage && sendQuickMessage}
      <div className='d-flex flex-row card-number-div-wrapper'></div>

      <div className='col-md-12'>
        <div
          className='card mt-4'
          style={{
            backgroundImage: `url(${toAbsoluteUrl('/media/bg-gradient-quick-message.png')})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className='d-flex align-items-center justify-content-between' style={{
                        padding: '24px 36px',                       
          }}>
              <div>
                <p
                  className='display-6 text-primary lh-base mb-2 fw-boldest'
                  style={{letterSpacing: '-0.01em', fontSize: '24px'}}
                >
                  🚀 Get Started with Your First Message!
                </p>
                <p className='fs-5 lh-sm' style={{color: '#3F4254', fontWeight: 500}}>
                    Effortlessly <em>upload your contacts, create and send</em> SMS or MMS to engage your audience in <br /> minutes. Launch your first message today!
                </p>
              </div>
              <div className='d-flex justify-content-center align-items-center' style={{width:'235px', height:'40px'}}>
                <Link to='/new-message' className='btn btn-primary w-100'>
                  Create Campaign
                </Link>
              </div>
          </div>
        </div>

        <div className='row mt-5'>
          {/* Left Side */}
          <div className='col-md-8'>
            <div className='row'>
              {/* Contacts and Credit Section */}
              <div className='col-md-6'>
                <div className='card h-100 py-2'>
                  <div className='card-header border-0 pt-5'>
                    <h3 className='card-title'>
                    <img
                    src={toAbsoluteUrl('/media/icons/profile_2user.png')}
                    className=''
                    alt='contact'
                    width={30}
                    height={30}
                  />

                      <span className='card-label'>Contact</span>
                    </h3>
                  </div>
                  <div className='d-flex flex-column card-body justify-content-between'>
                    <div className='row text-center'>
                      <div className='col-6'>
                        <h2 className='card-body-value'>{countSubscriber?.data ?? 0}</h2>
                        <h5 className='text-subtitle-2'>Subscribed</h5>
                      </div>
                      <div className='col-6'>
                        <h2 className='card-body-value'>{countUnsubscribe?.data ?? 0}</h2>
                        <h5 className='text-subtitle-2'>Unsubscribed</h5>
                      </div>
                    </div>
                    <div className='text-center mt-4'>
                      <Link
                        to='/contacts/subscriber'
                        className='btn btn-light-primary-with-hover w-100 fw-bolder'
                      >
                        Add Contact
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-md-6'>
                <div className='card h-100 py-2'>
                  <div className='card-header border-0 pt-5'>
                    <h3 className='card-title'>
                    <img
                    src={toAbsoluteUrl('/media/icons/wallet.png')}
                    className=''
                    alt='wallet'
                    width={30}
                    height={30}
                  />
                      <span className='card-label'>Credit</span>
                    </h3>
                  </div>
                  <div className='d-flex flex-column card-body justify-content-between'>
                    <div className='row text-center'>
                      <div className='col-6'>
                        <h2 className='card-body-value'>
                          {isShowCredit
                            ? FixedTwoDecimal(credits?.credits?.sms || 0)
                            : shareCreditRemain.sms}
                        </h2>
                        <p className='text-subtitle-2 text-success'>SMS Credit</p>
                      </div>
                      <div className='col-6'>
                        <h2 className='card-body-value'>
                          {isShowCredit
                            ? FixedTwoDecimal(credits?.credits?.mms || 0)
                            : shareCreditRemain.mms}
                        </h2>
                        <p
                          className='text-subtitle-2'
                          style={{
                            color: 'var(--color-azure-62, #3E97FF)',
                          }}
                        >
                          MMS Credit
                        </p>
                      </div>
                    </div>
                    <div className='text-center mt-4'>
                      <Link to='/topup' className='btn btn-light-primary-with-hover w-100 fw-bolder'>
                        Buy Credit
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Calendar Section */}
            <CalendarDashboard />
          </div>

          {/* Right Side */}
          <div className='col-md-4'>
            {/* Snapshot Section */}
            <div className='card py-2'>
              <div className='card-header border-0 pt-5'>
                <h3 className='d-flex card-title align-items-center'>
                <img
                    src={toAbsoluteUrl('/media/icons/flash_circle.png')}
                    className=''
                    alt='snapshot'
                    width={32}
                    height={32}
                  />

                  <div className='d-flex flex-column'>
                    <span className='card-label mb-1'>Snapshot</span>
                    <span className='text-body-2'>Last Campaign Snapshot</span>
                  </div>
                </h3>
              </div>
              <div className='card-body'>
                <div
                  className='d-grid'
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '20px',
                    height: '100%',
                  }}
                >
                  {/* Send Messages */}
                  <OverlayTrigger
                    placement='bottom'
                    overlay={<Tooltip id='button-tooltip-dashboard' className='custom-tooltip'>Message delivered to customers</Tooltip>}
                  >
                    <div className='d-flex flex-column cursor-pointer'>
                      <h1 className='card-body-value-2 text-start'>
                        {lastSnapshot?.recipients ?? 0}
                      </h1>
                      <span className='text-item text-start'>Send messages</span>
                    </div>
                  </OverlayTrigger>

                  {/* Replies Messages */}
                  <OverlayTrigger
                    placement='bottom'
                    overlay={<Tooltip id='button-tooltip-dashboard' className='custom-tooltip'>Replies from customers</Tooltip>}
                  >
                    <div className='d-flex flex-column cursor-pointer'>
                      <h1 className='card-body-value-2 text-start'>{lastSnapshot?.replies ?? 0}</h1>
                      <span className='text-item text-start'>Replies messages</span>
                    </div>
                  </OverlayTrigger>

                  {/* Bounce Messages */}
                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip id='button-tooltip-dashboard' className='custom-tooltip'>Message failed, expired and blocked</Tooltip>
                    }
                  >
                    <div className='d-flex flex-column cursor-pointer'>
                      <h1 className='d-flex card-body-value-2 align-items-center text-start'>
                        {lastSnapshot?.bouncedMessage ?? 0}
                        {lastSnapshot?.bouncedMessage > 0 && (
                          <span
                            className='badge ms-2'
                            style={{
                              display: 'inline-block',
                              width: 'auto',
                              height: '17px',
                              padding: '0px 4px',
                              borderRadius: '6px',
                              fontSize: '12px',
                              fontWeight: '400',
                              lineHeight: '16.8px',
                              textAlign: 'left',
                              background: '#F53B6E1F',
                              color: '#F15642',
                            }}
                          >
                            {handleCalculateBadgePercentage(
                              lastSnapshot?.bouncedMessage,
                              lastSnapshot?.recipients
                            )}
                            %
                          </span>
                        )}
                      </h1>
                      <span className='text-item text-start'>Bounce Messages</span>
                    </div>
                  </OverlayTrigger>

                  {/* Unsubscribed */}
                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip id='button-tooltip-dashboard' className='custom-tooltip'>Customers has responded to unsubscribe</Tooltip>
                    }
                  >
                    <div className='d-flex flex-column cursor-pointer'>
                      <h1 className='d-flex card-body-value-2 align-items-center text-start'>
                        {lastSnapshot?.unsub ?? 0}
                        {lastSnapshot?.unsub > 0 && (
                          <span
                            className='badge ms-2'
                            style={{
                              display: 'inline-block',
                              width: 'auto',
                              height: '17px',
                              padding: '0px 4px',
                              borderRadius: '6px',
                              fontSize: '12px',
                              fontWeight: '400',
                              lineHeight: '16.8px',
                              textAlign: 'left',
                              background: '#F53B6E1F',
                              color: '#F15642',
                            }}
                          >
                            {handleCalculateBadgePercentage(
                              lastSnapshot?.unsub,
                              lastSnapshot?.recipients
                            )}
                            %
                          </span>
                        )}
                      </h1>
                      <span className='text-item text-start'>Unsubscribed</span>
                    </div>
                  </OverlayTrigger>

                  {/* Click */}
                  <OverlayTrigger
                    placement='bottom'
                    overlay={
                      <Tooltip id='button-tooltip-dashboard' className='custom-tooltip'>Short url and landing page url clicks</Tooltip>
                    }
                  >
                    <div className='d-flex flex-column cursor-pointer'>
                      <h1 className='d-flex card-body-value-2 align-items-center text-start'>
                        {lastSnapshot?.clickThrough ?? 0}
                        {lastSnapshot?.clickThrough > 0 && (
                          <span
                            className='badge ms-2'
                            style={{
                              display: 'inline-block',
                              width: 'auto',
                              height: '17px',
                              padding: '0px 4px',
                              borderRadius: '6px',
                              fontSize: '12px',
                              fontWeight: '400',
                              lineHeight: '16.8px',
                              textAlign: 'left',
                              background: '#85A7FF1F',
                              color: 'var(--color-azure-62, #3E97FF)',
                            }}
                          >
                            {handleCalculateBadgePercentage(
                              lastSnapshot?.clickThrough,
                              lastSnapshot?.recipients
                            )}
                            %
                          </span>
                        )}
                      </h1>
                      <span className='text-item text-start'>Click</span>
                    </div>
                  </OverlayTrigger>

                  {/* Engagement */}
                  <OverlayTrigger
                    placement='bottom'
                    overlay={<Tooltip id='button-tooltip-dashboard' className='custom-tooltip'>Replies + Link clicks</Tooltip>}
                  >
                    <div className='d-flex flex-column cursor-pointer'>
                      <h1 className='card-body-value-2 text-start'>{lastTotalEngagement ?? 0}</h1>
                      <span className='text-item text-start'>Engagement</span>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>

            {/* Configurations Section */}
            <div className='card mt-6 py-2'>
              <div className='card-header border-0 pt-5'>
                <h3 className='d-flex card-title align-items-center'>
                <img
                    src={toAbsoluteUrl('/media/icons/setting_2.png')}
                    className=''
                    alt='setting'
                    width={32}
                    height={32}
                  />
                  <div className='d-flex flex-column'>
                    <span className='card-label mb-1'>Configurations</span>
                    <span className='text-body-2'>Integrations, API and more</span>
                  </div>
                </h3>
              </div>
              <div className='card-body'>
                {configData?.map((data, idx) => (
                  <div className='row mb-5' key={idx}>
                    <div className='col-10'>
                      <h3 className='d-flex flex-column card-title align-items-start'>
                        <span className='text-title-3'>{data.title}</span>
                      </h3>
                      <span className='text-body-3 w-100px'>{data.description}</span>
                    </div>
                    <div className='col-2 d-flex flex-end align-items-center p-1'>
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='button-tooltip-dashboard'>View Detail</Tooltip>}
                      >
                        <a
                          onClick={() => navigate(data?.path)}
                          className='btn btn-active-color-primary btn-bg-light btn-icon btn-sm'
                        >
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr064.svg'
                            className='svg-icon-2'
                          />
                        </a>
                      </OverlayTrigger>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ChartDashboard

const CalendarDashboard = () => {
  const dispatch = useDispatch()
  const calendarRef = useRef<FullCalendar | null>(null)
  const calanderData = useSelector(getFEdashboardCalander)
  const [campType, setCampType] = useState('sms')
  const [eventHoverInfo, setEventHoverInfo] = useState<any>(null)
  const [popupPosition, setPopupPosition] = useState<{left: number; top: number}>({left: 0, top: 0})
  const popupRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    fetchCalendarData()
  }, [campType])

  const fetchCalendarData = () => {
    const calendarApi = calendarRef.current?.getApi()
    if (!calendarApi) return

    dispatch(
      FrontendDashboardCalanderData({
        fromDate: moment(calendarApi.getCurrentData().currentDate)
          .startOf('month')
          .format('YYYY-MM-DD'),
        toDate: moment(calendarApi.getCurrentData().currentDate)
          .endOf('month')
          .format('YYYY-MM-DD'),
        camp_type: campType,
      })
    )
  }

  const handleClickOutside = (event: MouseEvent) => {
    // If the popup exists and the clicked element is NOT inside the popup, close it.
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      setEventHoverInfo(null)
    }
  }

  // Outside click listener
  useEffect(() => {
    // Listen for mousedown events on the whole document
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const calendarEvents = () => {
    return calanderData?.map((event: any) => ({
      id: event._id,
      title: event.name,
      color: event.camp_type === 'sms' ? '#00BA341A' : '#0085FF1A',
      textColor: event.camp_type === 'sms' ? '#00BA34' : '#0085FF',
      date: moment(event.scheduleAt || event.createdAt).format('YYYY-MM-DD'),
      extendedProps: {
        description: moment(event.scheduleAt || event.createdAt).format('LLL'),
        message: event.message,
        campType: event.camp_type,
        recipients: event.recipients,
        creditAmount: event.creditAmount,
      },
    }))
  }

  const handleEventClick = (info: any) => {
    const cursorX = info.jsEvent.clientX
    const cursorY = info.jsEvent.clientY
    const popupWidth = 300
    const popupHeight = 150
    const offset = 10
    const screenWidth = window.innerWidth

    const left =
      cursorX + popupWidth + offset > screenWidth ? cursorX - popupWidth - offset : cursorX + offset

    let top = cursorY - popupHeight - offset
    if (top < 0) {
      top = cursorY + offset
    }

    setPopupPosition({left, top})
    const eventDetails = calanderData?.find((event: any) => event._id === info.event.id)
    setEventHoverInfo(eventDetails || null)
  }

  const handleMonthChange = (direction: 'next' | 'prev') => {
    const calendarApi = calendarRef.current?.getApi()
    if (!calendarApi) return

    const newDate =
      direction === 'next'
        ? moment(calendarApi.getCurrentData().currentDate).add(1, 'month')
        : moment(calendarApi.getCurrentData().currentDate).subtract(1, 'month')

    dispatch(
      FrontendDashboardCalanderData({
        fromDate: newDate.startOf('month').format('YYYY-MM-DD'),
        toDate: newDate.endOf('month').format('YYYY-MM-DD'),
        camp_type: campType,
      })
    )

    direction === 'next' ? calendarApi.next() : calendarApi.prev()
  }

  const handleStoreReportId = (id: any, campType: string, data: any) => {
    dispatch(
      storeReportId({
        id: id,
        camp_type: campType,
        data: data,
      })
    )
  }

  const getCreditText = (eventHoverInfo: any): React.ReactNode => {
    if (!eventHoverInfo) return '-'
    const creditAmount =
      eventHoverInfo.creditAmount != undefined &&
      eventHoverInfo.creditAmount != null &&
      eventHoverInfo.creditAmount >= 0
        ? eventHoverInfo.creditAmount
        : eventHoverInfo.deductibleCredits

    return `${creditAmount} ${campType.toUpperCase()}  Credit${creditAmount > 1 ? 's' : ''}`
  }

  return (
    <div className='calender_wrapper'>
      <div className='calender-main py-6'>
        <div className='card'>
          <div className='card-body'>
            <div className='calender-style'>
              <FullCalendar
                ref={calendarRef}
                headerToolbar={{
                  start: 'prevButton',
                  center: 'title',
                  end: 'nextButton',
                }}
                customButtons={{
                  nextButton: {
                    text: '',
                    click: () => handleMonthChange('next'),
                    icon: 'chevron-right',
                  },
                  prevButton: {
                    text: '',
                    click: () => handleMonthChange('prev'),
                    icon: 'chevron-left',
                  },
                }}
                eventClick={handleEventClick}
                plugins={[dayGridPlugin]}
                initialView='dayGridMonth'
                events={calendarEvents()}
              />
            </div>
            {eventHoverInfo && (
              <div
                className='new-popup'
                ref={popupRef}
                style={{left: popupPosition.left, top: popupPosition.top}}
              >
                <h3
                  className='title-1'
                  style={{color: eventHoverInfo.camp_type === 'sms' ? '#74CA8F' : '#0085FF'}}
                >
                  {eventHoverInfo.camp_type.toUpperCase()}
                  {eventHoverInfo.scheduleAt && new Date(eventHoverInfo.scheduleAt) > new Date() && (
                    <span
                      className='badge ms-2'
                      style={{
                        display: 'inline-block',
                        width: '68px',
                        height: '21px',
                        borderRadius: '4px',
                        padding: '4px 8px',
                        fontSize: '10px',
                        fontWeight: '600',
                        lineHeight: '13px',
                        letterSpacing: '-3%',
                        textAlign: 'left',
                        background: '#F53B6E1F',
                        color: '#7950F2',
                      }}
                    >
                      {'Scheduled'}
                    </span>
                  )}
                </h3>
                <h2 className='mb-3 title-2'>{eventHoverInfo.name}</h2>
                <div className='d-flex flex-column gap-1 mb-2'>
                  <label className='label'>Created</label>
                  <span>
                    {eventHoverInfo.createdAt
                      ? moment(eventHoverInfo.createdAt).format('D MMMM YYYY')
                      : '-'}
                  </span>
                </div>
                <div className='d-flex flex-column gap-1 mb-2'>
                  <label className='label'>Send on</label>
                  <span>{moment(eventHoverInfo.date).format('D MMMM YYYY, h.mm a')}</span>
                </div>
                <div className='d-flex flex-column gap-1 mb-2'>
                  <label className='label'>Recipient</label>
                  <span>
                    {eventHoverInfo.recipients} Contact{eventHoverInfo.recipients > 1 ? 's' : ''}
                  </span>
                </div>
                <div className='d-flex flex-column gap-1 mb-2'>
                  <label className='label'>Credit</label>
                  <span>{getCreditText(eventHoverInfo)}</span>
                </div>
                <div className='d-flex justify-content-center mt-4'>
                  <Link
                    to='/eofy/snapshot'
                    target='_blank'
                    onClick={() =>
                      handleStoreReportId(
                        eventHoverInfo._id,
                        eventHoverInfo.camp_type,
                        eventHoverInfo
                      )
                    }
                    className='btn'
                  >
                    <label className='button-label'>Detail</label>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
